import { render, staticRenderFns } from "./houseDetails.vue?vue&type=template&id=0740be0c&scoped=true&"
import script from "./houseDetails.vue?vue&type=script&lang=js&"
export * from "./houseDetails.vue?vue&type=script&lang=js&"
import style0 from "./houseDetails.vue?vue&type=style&index=0&id=0740be0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740be0c",
  null
  
)

export default component.exports